import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Page } from '../models/page';
import { PagesizeType } from '../../event/service/pagination/pagesize-type';
import { UserLocalStorageService } from '../../permission/services/user.local.storage.service';

@Component({
  selector: 'pioneer-pagination',
  templateUrl: './pagination.component.html'
})
export class PaginationComponent<T> implements OnChanges, OnInit {

  @Input()
  pagesizeType: PagesizeType; // *required

  @Input()
  resultsPage: Page<T>;

  @Output()
  public updatePage: EventEmitter<{page: number, itemsPerPage: number}> = new EventEmitter<{page: number, itemsPerPage: number}>();

  selectedItemsPerPage;

  constructor(private userLocalStorageService: UserLocalStorageService) { }

  ngOnInit() {
    if (this.pagesizeType === undefined) {
      throw new Error('The "paginatedList" input is undefined');
    } else {
      this.selectedItemsPerPage = this.userLocalStorageService.getPagesize(this.pagesizeType);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const pagesize = this.userLocalStorageService.getPagesize(this.pagesizeType);
    this.selectedItemsPerPage = this.resultsPage ? this.resultsPage.size : pagesize;
    this.userLocalStorageService.setPagesize(this.pagesizeType, this.selectedItemsPerPage);
  }

  get firstPageItemNumber(): number {
    return (this.resultsPage.number * this.resultsPage.size) + 1;
  }

  get lastPageItemNumber(): number {
    return (this.resultsPage.number * this.resultsPage.size) + this.resultsPage.numberOfElements;
  }

  get currentPageNumber(): number {
    return this.resultsPage.number + 1;
  }

  goToPage(pageNumber?: number) {
    const page = pageNumber ? pageNumber - 1 : this.currentPageNumber - 1;
    const itemsPerPage = this.selectedItemsPerPage;
    this.updatePage.emit({page, itemsPerPage});
  }

  onChangeItemsPerPage(newItemsPerPage: number) {
    this.selectedItemsPerPage = newItemsPerPage;
    this.userLocalStorageService.setPagesize(this.pagesizeType, this.selectedItemsPerPage);
    this.goToPage();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pagination/pagination.component.ts